// src/components/CommentList.js
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Avatar, AvatarFallback } from '../components/ui/avatar';
import { Separator } from '../components/ui/separator';
import { Calendar } from 'lucide-react';

const CommentList = ({ comments }) => {
  if (!comments || comments.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Comments</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground py-8 text-center">
            No comments yet. Be the first to share your thoughts!
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Comments ({comments.length})</CardTitle>
      </CardHeader>
      <CardContent className="space-y-8">
        {comments.map((comment, index) => (
          <div key={comment.id}>
            <div className="flex gap-4">
              <Avatar className="h-10 w-10">
                <AvatarFallback className="bg-primary/10 text-primary font-medium">
                  {comment.user?.username?.charAt(0).toUpperCase() || 'U'}
                </AvatarFallback>
              </Avatar>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-foreground">
                    {comment.user?.username || 'Anonymous'}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-muted-foreground">
                    <Calendar className="h-3.5 w-3.5" />
                    {new Date(comment.created_at).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </div>
                </div>

                <div className="mt-2 text-[15px] leading-relaxed text-foreground/90">
                  {comment.content}
                </div>
              </div>
            </div>

            {index < comments.length - 1 && <Separator className="mt-8" />}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default CommentList;
